const DEFAULT_MARKETING_LANDING_VIDEO_SRC = "/videos/landing-demo.mp4";

/**
 * Landing hero “watch video” source for react-player v3 (`src`).
 *
 * Set `NEXT_PUBLIC_MARKETING_LANDING_VIDEO_SRC` to override the default file path, for example:
 * - `https://www.youtube.com/watch?v=VIDEO_ID`
 * - `https://vimeo.com/123456789`
 * - `/videos/landing-demo.mp4` (default)
 */
export function getMarketingLandingVideoSrc(): string {
	const fromEnv = process.env.NEXT_PUBLIC_MARKETING_LANDING_VIDEO_SRC?.trim();
	return fromEnv && fromEnv.length > 0
		? fromEnv
		: DEFAULT_MARKETING_LANDING_VIDEO_SRC;
}
